import { useQuery } from "@tanstack/react-query";
import { jsonFetch } from "@/lib/json-fetch";
import { solutionDemandLinkKeys } from "@/lib/query";

export type SolutionDemandLink = {
  id: string;
  nymblDemandId: string;
  demandName: string | null;
  linkedAt: string;
  lastSyncedAt: string | null;
};

export type SolutionDemandLinksResponse = {
  links: SolutionDemandLink[];
};

/** The NOS Demand links for one Solution — the "Demand Link" tab in the drawer. */
export function useSolutionDemandLinks(solutionId: string) {
  return useQuery({
    queryKey: solutionDemandLinkKeys.detail(solutionId),
    queryFn: () =>
      jsonFetch<SolutionDemandLinksResponse>(`/api/dashboard/solutions/${solutionId}/demand-links`),
  });
}
